// Owner report 2026-09-25: stores showed "null" in Apt / Suite — the string a
// FormData makes of a null apartment. The API now keeps null (StoreApartment);
// this keeps any value that already says "null" off the screen. Call it when a
// form loads, never on an input's bound value — it trims, and trimming each
// keystroke ate the spaces people typed ("Suite 200" saved "Suite200").
export const apartmentValue = (value) => {
  const text = value === null || value === undefined ? '' : String(value).trim();
  return text.toLowerCase() === 'null' ? '' : text;
};
